<ion-grid>
  <ion-row class="margin-bottom-l">
    <ion-col class="ion-no-padding ion-text-center" size="12">
      <ion-text class="delete-product-title">
        {{ 'Modals.delete-product-cart.title' | translate }}
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row class="margin-bottom-l">
    <ion-col class="ion-no-padding ion-text-center" size="12">
      <ion-text class="delete-product-body">
        {{ 'Modals.delete-product-cart.text' | translate }}
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col class="delete-product-buttons" size="12">
      <getm-button [text]="'Modals.delete-product-cart.cancelButton' | translate" color="primary" size="large" expand="block" (click)="onCancel()"></getm-button>
      <getm-button [text]="'Modals.delete-product-cart.confirmButton' | translate" color="tertiary" size="large" expand="block" (click)="onConfirmDelete()"></getm-button>
    </ion-col>
  </ion-row>
</ion-grid>
